import { gettext } from '@eventbrite/i18n';
import { TimeSlotProps } from '@eventbrite/timed-entry';

export enum DateFormatType {
    short = 'short',
    long = 'long',
}

export const TAB_HEADERS: Array<string> = [
    gettext('Morning').toString(),
    gettext('Afternoon').toString(),
    gettext('Night').toString(),
];

export const SESSION_SIZE = 32;

export type DayPart = {
    Morning: TimeSlotProps[];
    Afternoon: TimeSlotProps[];
    Night: TimeSlotProps[];
};
